import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownButtonItemDirective, DropDownButtonItemsDirective } from './items.directive';
import { DropDownButtonComponent } from './dropdownbutton.component';
import { DropDownButtonModule } from './dropdownbutton.module';
/**
 * NgModule definition for the DropDownButton component with providers.
 */
export class DropDownButtonAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, DropDownButtonModule],
    exports: [
        DropDownButtonModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropDownButtonAllModule_tsickle_Closure_declarations() {
/** @type {?} */
DropDownButtonAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownButtonAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
